<span class="loading activeLoading {{bg_color}}" *ngIf="type === 'default'"></span>
<span class="square {{bg_color}}" [ngStyle]="square_style" *ngIf="type === 'square'">
  <svg width="25" height="25" viewBox="0 0 40 40">
    <!-- <rect width="40" height="40" class="rect" /> -->
    <polygon points="0 0 0 40 40 40 40 0" class="rect"></polygon>
  </svg>
</span>